const Autodesk = window.Autodesk;
import store from '@/store';
import { removeFromScene, setForgeCropBox, pointerToRaycaster } from '../utils/forgeUtils'
import { getBoxControlArrows, drawBoxLines, getBoxOffset } from '../utils/threejsUtils'
const THREE = window.THREE;

class Cropping3DExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        this.webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        let _this = this;
        this.clickEvent = (event)=>{
            _this.onMouseUp(event);
        }
        this.webGLDOM.addEventListener("click",this.clickEvent);
        this.viewer.canvas.addEventListener("mousedown",(event)=>{
            _this.onMouseDown(event);
        });
        this.webGLDOM.addEventListener("mousemove",(event)=>{
            _this.onMouseMove(event);
        },false);
        this.sceneName = 'potree-scene';
        this.cropBoxColor  = 0x5A002A;
        this.cropBoxOffsetColor  = 0xff0000;
        this.pointsColor = 0x000000;

        this.cropBox = null;
        this.cropBoxOffsetMesh = null;
        this.cropBoxMesh = null;
        this.cropBoxPoints = [];
        this.draggingArrowIndex = -1;
        this.cropBoxOrigin = null;//the point in the middle of the cropBox
        
        this.draggingPoint = null;
        this.highlightedTriangles = null;

        this.croppingOn = false;
        this.pointTypes ={
            Front : 'Front',
            Back : 'Back',
            Left : 'Left',
            Right : 'Right',
            Top : 'Top',
            Bottom : 'Bottom',
        }
        
    }
    
    load() {
        let _this = this;
        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
            if(!_this.croppingOn||!_this.cropBox)
                return;
           _this.setCropBoxControls(_this.cropBox);
           _this.viewer.impl.invalidate(false, false, true);
        });

        return true;
    }
    unload() {
        this.webGLDOM.removeEventListener("click",this.clickEvent);

        return true;
    }
    onToolbarCreated() {

    }
    toggleCropbox(show){
        this.croppingOn = show;
        if (!show) {
            removeFromScene(this.cropBoxOffsetMesh, this.viewer, this.sceneName);
            removeFromScene(this.cropBoxMesh, this.viewer, this.sceneName);
            removeFromScene(this.cropBoxPoints.map(o => o.arrow.arrow),this.viewer,this.sceneName);
            removeFromScene(this.cropBoxPoints.map(o => o.arrow.cylinder),this.viewer,this.sceneName);
            this.setCropBox(null);
        } else {
            this.setCropBox(this.cropBox);
            this.setCropBoxControls(this.cropBox);
        }
        this.viewer.impl.invalidate(true, true, true);
    }    
    setCropBoxControls(bBox) {
        //cleared previous drawn
        removeFromScene(this.cropBoxMesh,this.viewer,this.sceneName);
        removeFromScene(this.cropBoxPoints.map(o => o.arrow.arrow),this.viewer,this.sceneName);
        removeFromScene(this.cropBoxPoints.map(o => o.arrow.cylinder),this.viewer,this.sceneName);

        //draw new
        this.cropBoxMesh = drawBoxLines(bBox, this.cropBoxColor,this.viewer,this.sceneName);
        this.drawOffsetCropBox();

        this.cropBoxPoints = getBoxControlArrows(bBox, this.viewer, this.sceneName, 1);
    }
    setCropBox(box){
        this.cropBox = box ? box.clone() : null;
        setForgeCropBox(box,this.viewer);
        var mainExtension = store.state.forgeService.getMainExtension();
        if (mainExtension._pointclouds) {
            var pointclouds = Array.from(mainExtension._pointclouds.values());
            if (pointclouds.length == 0)
                return;
            pointclouds.forEach(o => o.setClippingBoxNew(box));
        }
        //update cropped 3d icons
        store.state.forgeService.updateAll3DIcons();

        if (box) store.dispatch('updateImagesInCropbox');
    }
    drawOffsetCropBox() {
        removeFromScene(this.cropBoxOffsetMesh, this.viewer, this.sceneName);
        if (!this.cropBox)
            return;
        let offset = parseFloat(store.getters['getDownloadBoxOffset']) / this.viewer.model.getUnitScale();
        if (offset == 0)
            return;
        let offsetBox = getBoxOffset(this.cropBox, offset)
        this.cropBoxOffsetMesh = drawBoxLines(offsetBox, this.cropBoxOffsetColor, this.viewer, this.sceneName);
    }
    checkAndHighlightControlUnderMouse(raycaster,assign){
        //snap to nearest point up to 20 pixels
        let sortedPts = this.cropBoxPoints.map(o => o);
        //search for arrow
        let clynders = sortedPts.map(o => o.arrow.cylinder);
        let cones = sortedPts.map(o => o.arrow.arrow.cone);
        let intersection = raycaster.intersectObjects(clynders);
        let index = -1;
        if (intersection.length > 0)
            index = clynders.indexOf(intersection[0].object);
        else {
            intersection = raycaster.intersectObjects(cones);
            if(intersection.length>0)
                index = cones.indexOf(intersection[0].object);
        }
        if (index != -1) {
            //highlight arrow
            if (index != -1) {
                this.highlightedTriangles = sortedPts[index].highlight();
                clynders[index].material.color = new THREE.Color(0xFFA500);
                cones[index].material.color = new THREE.Color(0xFFA500);

                if (assign)
                    this.draggingPoint = sortedPts[index];
                return true;
            }
        }
        return false;
    }
    onMouseMove(mouse) {
        //clear highlight triangles
        removeFromScene(this.highlightedTriangles,this.viewer,this.sceneName);
        this.highlightedTriangles = null;
        if (!this.croppingOn || !this.viewer.impl)
            return;
        let raycaster = pointerToRaycaster(this.viewer, mouse);
        
        //reset arrows colors
        this.cropBoxPoints.forEach(o=>o.arrow.cylinder.material.color = new THREE.Color(o.color));
        this.cropBoxPoints.forEach(o=>o.arrow.arrow.cone.material.color = new THREE.Color(o.color));

        if (this.draggingPoint) {
            let center = this.cropBox.getCenter();
            let min = this.cropBox.min;
            let max = this.cropBox.max;
            let plane = null;
            if (this.draggingPoint.type == 'Top' || this.draggingPoint.type == 'Bottom')
                plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), -center.y);
            else
                plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), -center.z);
            let intersection = raycaster.ray.intersectPlane(plane);
            if (!intersection)
                return;
            switch (this.draggingPoint.type) {
                case 'Front':
                    if (intersection.y < max.y) min.y = intersection.y;
                    break;
                case 'Back':
                    if (intersection.y > min.y) max.y = intersection.y;
                    break;
                case 'Left':
                    if (intersection.x < max.x) min.x = intersection.x;
                    break;
                case 'Right':
                    if (intersection.x > min.x) max.x = intersection.x;
                    break;
                case 'Bottom':
                    if (intersection.z < max.z) min.z = intersection.z;
                    break;
                case 'Top':
                    if (intersection.z > min.z) max.z = intersection.z;
                    break;
            }

            let newBox = new THREE.Box3(min, max);
            if (newBox.min.x > newBox.max.x || newBox.min.y > newBox.max.y || newBox.min.z > newBox.max.z) {
                newBox = this.cropBox;
                return;
            }
            this.setCropBox(newBox);
            this.highlightedTriangles = this.draggingPoint.highlight();
            this.setCropBoxControls(this.cropBox);
        }
        else
            this.checkAndHighlightControlUnderMouse(raycaster,false);
        
        this.cropBoxPoints.forEach(o=>o.arrow.cylinder.material.needsUpdate = true);
        this.cropBoxPoints.forEach(o=>o.arrow.arrow.cone.material.needsUpdate = true);
        this.viewer.impl.invalidate(false, false, true);
    }
    onMouseDown(mouse) {
        //clear highlight triangles
        removeFromScene(this.highlightedTriangles,this.viewer,this.sceneName);
        this.highlightedTriangles = null;

        if (mouse.which != 1 || !this.croppingOn)
            return;
        let raycaster = pointerToRaycaster(this.viewer, mouse);
        if(this.checkAndHighlightControlUnderMouse(raycaster,true))
            this.viewer.navigation.setIsLocked(true);
    }
    onMouseUp(mouse) {
        if (mouse.which != 1 || !this.croppingOn)
            return;
        this.draggingPoint = null;
        this.draggingArrowIndex = -1;
        this.isDraggingPlane = false;
        this.viewer.navigation.setIsLocked(false);
    }

}
Autodesk.Viewing.theExtensionManager.registerExtension('Cropping3DExtension', Cropping3DExtension);
